import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import styled from "styled-components";
import { analyticsFEA } from "src/AnalyticsFEA";
import { TradeInState } from "src/store/reducers/tradeIn";
import { localizeCurrencyToWholeNumber } from "src/utils";
import { isEmpty } from "src/utils/object";
import { VehicleState } from "Types/state";
import { TradeIn, Condition as TradeInCondition } from "Types/TradeIn";
import "./Condition.scss";
import ConditionOption from "./ConditionOption";

const ErrorMessage = styled("div")`
    color: ${(props) => props.theme.palette.error.main};
    font-style: italic;
    font-weight: normal;
    margin: 24px 0;
`;

interface ConditionProps {
    setSelect: (object: Partial<TradeIn>) => void;
    tradePending: Partial<TradeInState>;
    uuid: string;
    vehicles: VehicleState[];
}

class Condition extends React.Component<ConditionProps & WithTranslation> {
    public componentDidMount(): void {
        const { uuid, vehicles } = this.props;
        if (!isEmpty(this.props.tradePending)) {
            analyticsFEA.engine.tradeInEstimate(uuid, vehicles);
        }
    }

    public render() {
        const { t } = this.props;
        const greatDescription = t("TradePending.Condition.greatDescription");
        const goodDescription = t("TradePending.Condition.goodDescription");
        const fairDescription = t("TradePending.Condition.fairDescription");
        return (
            <div className="Condition__container" data-e2e="conditionContainer">
                {this.props.tradePending.errorMessage && (
                    <ErrorMessage>{this.props.tradePending.errorMessage}</ErrorMessage>
                )}

                <div className="Condition__header">
                    {t("TradePending.Condition.question", { model: this.props.tradePending.model })}
                </div>
                <div className="Condition__container--options">
                    <ConditionOption
                        description={fairDescription}
                        label={TradeInCondition.Low}
                        selected={this.props.tradePending.condition === TradeInCondition.Low}
                        setSelected={this.props.setSelect}
                        tradePending={this.props.tradePending}
                        valueRange={this.buildValueRanges(this.props.tradePending).low}
                    />
                    <ConditionOption
                        description={goodDescription}
                        label={TradeInCondition.Target}
                        selected={this.props.tradePending.condition === TradeInCondition.Target}
                        setSelected={this.props.setSelect}
                        tradePending={this.props.tradePending}
                        valueRange={this.buildValueRanges(this.props.tradePending).medium}
                    />
                    <ConditionOption
                        description={greatDescription}
                        label={TradeInCondition.High}
                        selected={this.props.tradePending.condition === TradeInCondition.High}
                        setSelected={this.props.setSelect}
                        tradePending={this.props.tradePending}
                        valueRange={this.buildValueRanges(this.props.tradePending).high}
                    />
                </div>
            </div>
        );
    }

    protected buildValueRanges = (tradein: any) => {
        const { t } = this.props;

        if (tradein && tradein.tp_tradein_low && tradein.tp_tradein_target && tradein.tp_tradein_high) {
            const values = {
                high: localizeCurrencyToWholeNumber(tradein.tp_tradein_high),
                lowOne: localizeCurrencyToWholeNumber(tradein.tp_tradein_low),
                lowTwo: localizeCurrencyToWholeNumber(tradein.tp_tradein_target - 1),
                mediumOne: localizeCurrencyToWholeNumber(tradein.tp_tradein_target),
                mediumTwo: localizeCurrencyToWholeNumber(tradein.tp_tradein_high - 1),
            };
            return {
                high: t("TradePending.Condition.rangeHight", { value: values.high }),
                low: t("TradePending.Condition.rangeLow", { valueOne: values.lowOne, valueTwo: values.lowTwo }),
                medium: t("TradePending.Condition.rangeMedium", {
                    valueOne: values.mediumOne,
                    valueTwo: values.mediumTwo,
                }),
            };
        } else {
            return {
                high: "",
                low: "",
                medium: "",
            };
        }
    };

    protected isConditionSelected = (label: string) => {
        return this.props.tradePending.condition && this.props.tradePending.condition === label ? true : false;
    };
}

export default withTranslation()(Condition);
